export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-page-copy-abd9efb0bbd86fa02d229bf44c789184.svg";